import ItemResultatDefault from './ItemResultatDefault';
import ItemResultatTransparencia from './ItemResultatTransparencia';
import ItemResultatGeneral from './ItemResultatGeneral';

export default function Component(props) {
    const { portal } = props;

    switch (portal) {
        case 'portalTransparencia':
            return <ItemResultatTransparencia {...props} />;
        case 'portalPremsa':
            return <ItemResultatDefault {...props} mostrarData='true' mostrarEntradeta='true' mostrarImatge='true' />;
        case 'general':
            return <ItemResultatGeneral {...props} />;
        default:
            return <ItemResultatDefault {...props} />;
    }
}
